import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { admin } from '../_models/admin';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentAdminSubject: BehaviorSubject<admin>;
  public currentAdmin: Observable<admin>;

  private isAdminSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public isAdmin$: Observable<boolean> = this.isAdminSubject.asObservable();

  constructor(private http: HttpClient, public router: Router) {
    this.currentAdminSubject = new BehaviorSubject<admin>(
      JSON.parse(localStorage.getItem('currentAdmin') || '{}')
    );
    this.currentAdmin = this.currentAdminSubject.asObservable();
  }

  public get currentAdminValue(): admin {
    return this.currentAdminSubject.value;
  }

  private handleError(error: any) {
    return throwError(error);
  }

  // User Login
  userLogin(formdata: any) {
    return this.http
      .post<any>(`${environment.baseURL}/auth/login`, formdata)
      .pipe(
        map((admin) => {
          admin.authdata = admin.data.token;
          localStorage.setItem('currentAdmin', JSON.stringify(admin.data));

          this.currentAdminSubject.next(admin);
          return admin;
        })
      );
  }

  // Log Out
  logout() {
    return this.http
      .get(`${environment.baseURL}/users/logout`)
      .pipe(catchError(this.handleError));
  }

  getCurrentUser(): Observable<any> {
    const tokenObjectString = JSON.parse(
      localStorage.getItem('currentAdmin') || ''
    );
    const headers = new HttpHeaders({
      Authorization: `Bearer ${tokenObjectString.token}`,
    });
    return this.http.get(environment.baseURL + `/auth/me`, { headers }).pipe(
      catchError((error) => {
        if (error.status === 401) {
          localStorage.clear();
          this.router.navigateByUrl('/admin/login');
        }
        return throwError(error);
      })
    );
  }

  setUserPermissions(permissions: any): void {
    if (permissions) {
      localStorage.setItem('userPermissions', JSON.stringify(permissions));
    }
  }

  setIsAdmin(isAdmin: boolean): void {
    if (isAdmin) {
      this.isAdminSubject.next(isAdmin);
    }
  }

  // User Permission
  UserRolePermission(): any {
    const storedPermissions = localStorage.getItem('userPermissions');
    if (storedPermissions) {
      return JSON.parse(storedPermissions);
    }
  }
}
